/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_Tab_TrialingInputs */

const en_settings_billing_tab_trialing = /** @type {(inputs: Settings_Billing_Tab_TrialingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trialing`)
};

/**
* | output |
* | --- |
* | "Trialing" |
*
* @param {Settings_Billing_Tab_TrialingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_billing_tab_trialing = /** @type {((inputs?: Settings_Billing_Tab_TrialingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_Tab_TrialingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_billing_tab_trialing(inputs)
});
export { settings_billing_tab_trialing as "settings.billing.tab_trialing" }